import React, { useEffect, useState } from 'react';

// Funciones de datos
import GenerarCredencial from '../functions/GenerarCredencial';
import ObtenerSocioDocumento from '../functions/ObtenerSocioDocumento';

// Indicador de procesamiento
import CircularProgress from '@mui/material/CircularProgress';

interface CredencialModalProps {
  nroDocumento?: string;
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

interface ImageResponse {
  imageBase64: string;
}

const CredencialModal: React.FC<CredencialModalProps> = ({ nroDocumento, isVisible, setIsVisible }) => {

  const [image, setImage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hayError, setHayError] = useState<boolean>(false);
  const [errorCodigo, setErrorCodigo] = useState<number>(0);
  const [errorMensaje, setErrorMensaje] = useState<string>('');
  const [planSocio, setPlanSocio] = useState<number>(0);

  const fetchImage = async (): Promise<void> => {

    setIsLoading(true);

    try {

      const responseCredencial = await GenerarCredencial(nroDocumento || '');
      
      if (responseCredencial.status === 'ok') {
        setHayError(false);
        setErrorCodigo(0);
        setErrorMensaje('');
        setImage(responseCredencial.credencial);
      } else {
          setHayError(true);
          setErrorCodigo(responseCredencial.errorCodigo);
          setErrorMensaje(responseCredencial.errorMensaje);
      }
      
      try {
        const datosSocio = await ObtenerSocioDocumento(nroDocumento || '');

        if (datosSocio.socio_ok === 'si') {
          setPlanSocio(datosSocio.socio[0].idplan);
        }
      } catch (error) {
        setHayError(true);
        setErrorCodigo(10102);
        setPlanSocio(0);
        setErrorMensaje('Error al obtener los datos del socio');
      }
    } catch (error) {
        setHayError(true);
        setErrorCodigo(10101);
        setErrorMensaje('Error al obtener la credencial');
    } finally {
      setIsLoading(false);
    }

  };

  useEffect(() => {
    if (isVisible) {
      fetchImage();
    }
  }, [isVisible]);

  const handleChangeDocumentos = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const documento = event.target.value;

    const pdfs = {
      pdf01: '/instructivos/Manual_de_Usuario_VidaPlus.pdf',
      pdf02: '/instructivos/Generar_Credencial.pdf',
      pdf03: '/instructivos/Prestaciones_Medicas.pdf',
      pdf04: '/instructivos/Odontologia.pdf',
      pdf05: '/instructivos/Opticas.pdf',
      pdf06: '/instructivos/Sepelio.pdf',
      pdf07: '/instructivos/Medico_a_Domicilio.pdf',
      pdf08: '/instructivos/Descuento_Farmacias.pdf',
      pdf09: '/instructivos/Asistencia_al_viajero.pdf',
      pdf10: '/instructivos/Seguro_de_Vida.pdf',
      pdf11: '/instructivos/Telemedicina.pdf',
      pdf12: '/instructivos/Seguro_de_Salud.pdf',
    };

    if (documento in pdfs) {
      window.open(pdfs[documento as keyof typeof pdfs], '_blank');
    }
    
  };

  return (
    <div>
      {isVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-85 flex justify-center items-center">
          <div className="bg-white flex flex-col justify-center items-center p-6 rounded-lg border-2 border-vp-azul">
            <h2 className="text-xl font-bold mb-4">Credencial Virtual</h2>
            {isLoading && (
              <div className="flex flex-col justify-center items-center h-96">
                  <h1 className="font-metropolis text-md font-medium">Generando credencial virtual...</h1>
                  <CircularProgress />
              </div>
            )}
            {(!isLoading && hayError )&& (
              <div className="flex flex-col justify-center items-center h-96">
                  <h1 className="font-metropolis text-md font-medium">Error {errorCodigo}</h1>
                  <p>{errorMensaje}</p>
              </div>
            )}
            {(!isLoading && !hayError) && (
              <div className="flex flex-col justify-center items-center h-96">
                <div className="flex flex-col justify-center items-center">
                  <img src={`data:image/jpeg;base64,${image}`} alt="Credencial Virtual" className="max-w-[280px] h-auto" />
                </div>
              </div>
            )}
            <button
              onClick={() => setIsVisible(false)}
              className="mt-3 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mb-3"
            >
              Cerrar
            </button>
            <div className="flex flex-col justify-end items-center">
              <select name="documentos" id="documentos" onChange={handleChangeDocumentos} className="mt-1 p-2 border-2 border-vp-azul rounded-md">
                <option value="Seleccionar Documento" selected disabled>Seleccionar Documento</option>
                <option value="pdf01">Manual de Uso</option>
                <option value="pdf02">Generar Credencial</option>
                <option value="pdf03">Prestaciones Médicas</option>
                <option value="pdf04">Odontología</option>
                <option value="pdf05">Ópticas</option>
                <option value="pdf06">Sepelio</option>
                {planSocio >=2 && (<option value="pdf07">Médico a Domicilio</option>)}
                {planSocio >=3 && (<option value="pdf08">Descuento en Medicamentos</option>)}
                {planSocio >=3 && (<option value="pdf09">Asistencia en Viajes</option>)}
                {planSocio >=3 && (<option value="pdf10">Seguro de Vida</option>)}
                {planSocio >=3 && (<option value="pdf11">Telemedicina</option>)}
                {planSocio >=4 && (<option value="pdf12">Seguro de Salud</option>)}
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CredencialModal;